/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeleteFacilityCustomTag200ResponseData } from './DeleteFacilityCustomTag200ResponseData';
import {
    DeleteFacilityCustomTag200ResponseDataFromJSON,
    DeleteFacilityCustomTag200ResponseDataFromJSONTyped,
    DeleteFacilityCustomTag200ResponseDataToJSON,
} from './DeleteFacilityCustomTag200ResponseData';

/**
 *
 * @export
 * @interface DeleteFacilityCustomTag200Response
 */
export interface DeleteFacilityCustomTag200Response {
    /**
     *
     * @type {DeleteFacilityCustomTag200ResponseData}
     * @memberof DeleteFacilityCustomTag200Response
     */
    data?: DeleteFacilityCustomTag200ResponseData;
}

/**
 * Check if a given object implements the DeleteFacilityCustomTag200Response interface.
 */
export function instanceOfDeleteFacilityCustomTag200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeleteFacilityCustomTag200ResponseFromJSON(json: any): DeleteFacilityCustomTag200Response {
    return DeleteFacilityCustomTag200ResponseFromJSONTyped(json, false);
}

export function DeleteFacilityCustomTag200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteFacilityCustomTag200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : DeleteFacilityCustomTag200ResponseDataFromJSON(json['data']),
    };
}

export function DeleteFacilityCustomTag200ResponseToJSON(value?: DeleteFacilityCustomTag200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': DeleteFacilityCustomTag200ResponseDataToJSON(value.data),
    };
}
